import React from "react";
import SparetiveLine from "../scripts/SparetiveLine";

const SpliterTest = () => {
    return (
        <div className="h-screen p-md">
            <div className="overflow-auto bg-throne rounded-xl ">
                <p className="text-center text-xl text-orange py-xl">src / Examples / SpliterTest.js</p>
                <Test text={"One"} />
            </div>
            <SparetiveLine vertical storageKey="cols" />
            <div>
                <div className="bg-cyan rounded-xl ">
                    <Test text={"Two"} />
                </div>
                <SparetiveLine storageKey="row-two" />
                <div className=" bg-red  rounded-xl ">
                    <Test text={"Three"} />
                </div>
                <SparetiveLine storageKey="row-two" />
                <div className="text-center bg-green rounded-xl">
                    <Test text={"Four"} />
                </div>
            </div>
        </div>
    );
};

export default SpliterTest;

const Test = ({ text }) =>
    Array.from({ length: 1 }).map((_, i) => (
        <p key={i} className="text-center ">
            {text}
        </p>
    ));
